// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const BuildingIcon = /* @__PURE__ */ createIcon(
  'building',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M20 12.6c0-.297-.001-.459-.01-.576l-.003-.012-.011-.001A8 8 0 0 0 19.4 12h-1.9v8H20zM13 14a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm0-4a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zm0-4a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2zM4 20h2.5v-8H4.6c-.297 0-.459.001-.576.01l-.012.002-.001.012C4 12.141 4 12.304 4 12.6zM15.5 6.2c0-.576-.001-.949-.024-1.232-.023-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.062-.422-.085A17 17 0 0 0 13.3 4h-2.6c-.576 0-.949.001-1.232.024-.272.023-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.062.15-.085.422-.023.283-.024.656-.024 1.232V20h7zm2 3.8h1.9c.264 0 .522-.001.739.017.228.018.498.063.77.2.328.169.604.424.796.737l.077.138.087.203c.072.2.1.395.114.566.018.217.017.475.017.739V20a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2v-7.4c0-.264-.001-.522.017-.739.018-.228.063-.498.2-.77a2 2 0 0 1 .875-.873c.271-.138.54-.183.77-.201.216-.018.474-.017.738-.017h1.9V6.2c0-.543-.001-1.012.03-1.395.033-.396.104-.789.297-1.167a3 3 0 0 1 1.31-1.31c.379-.194.772-.265 1.168-.298C9.688 2 10.157 2 10.7 2h2.6c.543 0 1.012-.001 1.395.03.396.033.789.104 1.167.297a3 3 0 0 1 1.31 1.31c.194.379.265.772.298 1.168.031.383.03.852.03 1.395z',
      },
    ],
  ]
);
